import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/PublicLayout";

import Home from "@/pages/public/Home";
import HowItWorks from "@/pages/public/HowItWorks";
import Services from "@/pages/public/Services";
import BecomeProfessional from "@/pages/public/BecomeProfessional";
import BuildBusiness from "@/pages/public/BuildBusiness";
import Providers from "@/pages/public/Providers";
import CommissionOpportunities from "@/pages/public/CommissionOpportunities";
import CommissionCalculatorPage from "@/pages/public/CommissionCalculatorPage";
import BusinessInABox from "@/pages/public/BusinessInABox";
import About from "@/pages/public/About";
import FAQ from "@/pages/public/FAQ";
import Legal from "@/pages/public/Legal";
import Join from "@/pages/public/Join";
import ProviderApplication from "@/pages/public/ProviderApplication";
import Login from "@/pages/public/Login";

import AgentApp from "@/pages/agent/AgentApp";
import AgentDashboard from "@/pages/agent/Dashboard";
import Leads from "@/pages/agent/Leads";
import Pipeline from "@/pages/agent/Pipeline";
import Opportunities from "@/pages/agent/Opportunities";
import ProvidersView from "@/pages/agent/ProvidersView";
import ReferralSources from "@/pages/agent/ReferralSources";
import Tasks from "@/pages/agent/Tasks";
import Commissions from "@/pages/agent/Commissions";
import CalculatorPage from "@/pages/agent/CalculatorPage";
import Training from "@/pages/agent/Training";
import Scripts from "@/pages/agent/Scripts";
import AIAssistant from "@/pages/agent/AIAssistant";
import Resources from "@/pages/agent/Resources";
import BuildMyBusiness from "@/pages/agent/BuildMyBusiness";
import Account from "@/pages/agent/Account";

import AdminApp from "@/pages/admin/AdminApp";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Exceptions from "@/pages/admin/Exceptions";
import AgentApplications from "@/pages/admin/AgentApplications";
import ProvidersAdmin from "@/pages/admin/ProvidersAdmin";
import Capacity from "@/pages/admin/Capacity";
import CommissionOppsAdmin from "@/pages/admin/CommissionOppsAdmin";
import CommissionsAdmin from "@/pages/admin/CommissionsAdmin";
import LeadsAdmin from "@/pages/admin/LeadsAdmin";
import Prospects from "@/pages/admin/Prospects";
import ContentFactory from "@/pages/admin/ContentFactory";
import Users from "@/pages/admin/Users";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/services" element={<Services />} />
              <Route path="/become-a-placement-professional" element={<BecomeProfessional />} />
              <Route path="/build-your-business" element={<BuildBusiness />} />
              <Route path="/providers" element={<Providers />} />
              <Route path="/commission-opportunities" element={<CommissionOpportunities />} />
              <Route path="/commission-calculator" element={<CommissionCalculatorPage />} />
              <Route path="/business-in-a-box" element={<BusinessInABox />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/join" element={<Join />} />
              <Route path="/provider-application" element={<ProviderApplication />} />
            </Route>
            <Route path="/login" element={<Login />} />

            <Route path="/app" element={<ProtectedRoute><AgentApp /></ProtectedRoute>}>
              <Route index element={<AgentDashboard />} />
              <Route path="leads" element={<Leads />} />
              <Route path="pipeline" element={<Pipeline />} />
              <Route path="opportunities" element={<Opportunities />} />
              <Route path="providers" element={<ProvidersView />} />
              <Route path="referral-sources" element={<ReferralSources />} />
              <Route path="tasks" element={<Tasks />} />
              <Route path="commissions" element={<Commissions />} />
              <Route path="calculator" element={<CalculatorPage />} />
              <Route path="training" element={<Training />} />
              <Route path="scripts" element={<Scripts />} />
              <Route path="ai" element={<AIAssistant />} />
              <Route path="resources" element={<Resources />} />
              <Route path="build" element={<BuildMyBusiness />} />
              <Route path="account" element={<Account />} />
            </Route>

            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminApp /></ProtectedRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="exceptions" element={<Exceptions />} />
              <Route path="agents" element={<AgentApplications />} />
              <Route path="providers" element={<ProvidersAdmin />} />
              <Route path="capacity" element={<Capacity />} />
              <Route path="opportunities" element={<CommissionOppsAdmin />} />
              <Route path="commissions" element={<CommissionsAdmin />} />
              <Route path="leads" element={<LeadsAdmin />} />
              <Route path="prospects" element={<Prospects />} />
              <Route path="content" element={<ContentFactory />} />
              <Route path="users" element={<Users />} />
              <Route path="settings" element={<SettingsAdmin />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
